/**
 * useCategories
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'

import CategoriesContext from './categories-context'

const useCategories = () => {
  const context = useContext(CategoriesContext)
  return context
}

export default useCategories
